import { Component, Input } from '@angular/core';
import { RoleMatrix } from '../../../../helpers';

@Component({
    selector: 'app-breadcrumb-work-order-activity-log',
    templateUrl: './breadcrumb.work.order.activity.log.component.html'
})

export class BreadcrumbWorkOrderActivityLogComponent {

    roleMatrix: RoleMatrix;

    @Input() companyId: number;
    @Input() workOrderId: number;

    constructor() {
        this.roleMatrix = new RoleMatrix();
    }
}
